import angular from 'angular';
import RemissionComponent from './remission.component';
import RemissionService from './remission.service';
import RemissionConfig from './remission.config';

let remissionModule = angular.module('app.reports.remission',[])
  .component('reportRemission', RemissionComponent)
  .service('ReportRemissionService', RemissionService)
  .config(RemissionConfig);

export default remissionModule;



/** WEBPACK FOOTER **
 ** ./www/components/reports/remission/remission.js
 **/